import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        formSubmission: '='
    },
    template: `
        <div class="quiz quiz02">
            <a class="btn discrete"
                    ng-if="vm.formSubmission.isTrial"
                    ui-sref="authorized.forms.forms.form.general({ id: vm.formSubmission.formId })"
                >{{ 'forms.Back to form' | translate }}</a>
            <div class="heading01">
                <h2>{{ vm.title }}</h2>
                <a class="btn discrete" ng-if="vm.inFrame && !vm.formSubmission.isTrial" ng-click="vm.closeQuiz()">
                    {{ 'general.Cancel' | translate }}
                </a>
                <forms-language-switcher form-submission="vm.formSubmission" selected-language="vm.selectedLanguage" ng-if="vm.formSubmission.isTrial" />
            </div>
            <p ng-if="vm.isQuizOverview" ng-bind-html="vm.overviewText"></p>
            <p ng-if="vm.showMandatoryText" class="desc"><span class="red">*</span> - {{ 'forms.This question is mandatory' | translate }}</p>
            <alert-error ng-if="vm.errors.length" ng-repeat="error in vm.errors">{{ error }}</alert-error>
            <alert-error ng-if="!vm.errors.length && vm.showGenericError">
                <p>
                    <span>{{ 'quiz.Something went wrong, answer was not saved.' | translate }}</span>
                    <span>{{ 'quiz.In case the problem reoccurs, please contact the administrator.' | translate }}</span>
                </p>
                <p>
                    <a class="btn" ng-click="vm.triggerSubmit()">{{ 'quiz.Send answer again.' | translate }}</a>
                </p>
            </alert-error>
            <alert-success ng-if="vm.showSuccessMessage">{{ 'quiz.Saving the answer was successful' | translate }}</alert-success>
            <quiz-questions ng-if="vm.questionsLoaded"
                form="vm.form"
                form-submission="vm.formSubmission"
                questions="vm.questions"
                selected-language="vm.selectedLanguage"
            />
        </div>
        <quiz-footer
            stop-timer="vm.stopTimer()"
            time-left="vm.timeLeft"
            form-submission="vm.formSubmission"
            form="vm.form"
            load-test="vm.loadTest(formSubmission)"
            show-button="vm.showButton"
            errors="vm.errors"
            show-generic-error="vm.showGenericError"
            show-success-message="vm.showSuccessMessage"
            is-quiz-overview="vm.isQuizOverview"
            is-page-before-overview="vm.isPageBeforeOverview"
        />
    `
})
export default class {
    constructor ($window, $interval, $scope, $state, $translate, moment, lodash, CommonResource,
                 FormSubmissionAnswerResource, FormSubmissionResource,
                 ModalService, TokenService, FormSubmissionService, QuizQuestionService,
                 FORMS_SUBMISSION_STATUS_ENUM, FORMS_DISPLAY_TYPE_ENUM) {
        this.$window = $window;
        this.$interval = $interval;
        this.$scope = $scope;
        this.$state = $state;
        this.$translate = $translate;
        this.moment = moment;
        this.lodash = lodash;
        this.CommonResource = CommonResource;
        this.FormSubmissionAnswerResource = FormSubmissionAnswerResource;
        this.FormSubmissionResource = FormSubmissionResource;
        this.ModalService = ModalService;
        this.TokenService = TokenService;
        this.FormSubmissionService = FormSubmissionService;
        this.QuizQuestionService = QuizQuestionService;
        this.FORMS_SUBMISSION_STATUS_ENUM = FORMS_SUBMISSION_STATUS_ENUM;
        this.FORMS_DISPLAY_TYPE_ENUM = FORMS_DISPLAY_TYPE_ENUM;
    }

    $onInit () {
        this.questionsLoaded = false;
        this.inFrame = self !== top;
        this.timeLeft = 0;
        this.isQuizOverview = false;
        this.isPageBeforeOverview = false;
        this.errors = [];
        this.showSuccessMessage = false;
        this.showGenericError = false;
        this.showMandatoryText = this.formSubmission.displayType === this.FORMS_DISPLAY_TYPE_ENUM.KEYS.ONE_PAGE;
        this.overviewText = this.$translate.instant('quiz.Overview text', { saveButton: this.$translate.instant('general.Save') });

        if (this.formSubmission.isTrial) {
            this.selectedLanguage = this.TokenService.getActiveLanguage();
        }

        this.loadTest(this.formSubmission, true);
        this.title = this.FormSubmissionService.getQuizTitle(this.formSubmission);
    }

    checkIfPageBeforeOverview (formSubmission) {
        const finished = formSubmission.finishedQuestionCount;
        const total = formSubmission.totalQuestionCount;

        // If questions are divided equally between pages, then questionsPerPage shows us how many questions
        // will be there in last page. If questions are not divided equally, then we are using php modulo
        // to get the remaining for last page
        const remainder = total % finished || 0;
        const questionsInLastPage = remainder === 0 ? formSubmission.form.questionsPerPage : remainder;
        const questionsMoreToAnswer = total - finished;

        return questionsMoreToAnswer === questionsInLastPage;
    }

    loadTest (formSubmission, isFirstLoad) {
        if (formSubmission.status === this.FORMS_SUBMISSION_STATUS_ENUM.KEYS.NOT_STARTED) {
            this.FormSubmissionResource.start({
                guid: formSubmission.guid,
                expand: 'form,occurrenceTraining,trainingActiveI18n'
            }).$promise.then((data) => {
                this.formSubmission = data;
                this.setTimer();
            });
        }
        else if (isFirstLoad) {
            this.setTimer();
        }

        this.isPageBeforeOverview = this.checkIfPageBeforeOverview(formSubmission);

        if (formSubmission.finishedQuestionCount === formSubmission.totalQuestionCount) {
            this.isQuizOverview = true;
            this.showMandatoryText = true;
        }

        this.questionsLoaded = false;
        this.QuizQuestionService.loadQuestions(formSubmission, this.isQuizOverview).then(questions => {
            if (formSubmission.form.isRandomizedAnswers) {
                questions = this.randomizeAnswers(questions);
            }
            this.questions = questions;
            this.afterLoadQuestions(formSubmission);
        });
    }

    randomizeAnswers (questions) {
        this.lodash.forEach(questions, question => {
            question.questionAnswers = this.lodash.shuffle(question.questionAnswers);
        });
        return questions;
    }

    afterLoadQuestions (formSubmission) {
        this.$window.scrollTo(0, 0);
        this.questionsLoaded = true;
        this.showButton = true;
        this.form = {
            guid: formSubmission.guid,
            formId: formSubmission.formId,
            answers: {}
        };
    }

    setTimer () {
        // make sure timeToAnswer  is set
        if (!this.formSubmission.endTime) {
            return;
        }
        const startTimeStamp = this.getCurrentTimestamp();
        const timeToAnswer = this.formSubmission.endTime - startTimeStamp;
        this.timer = this.$interval(() => {
            // we use actual time to get time left because  js exection time is delayed when tab is inactive
            const difference = timeToAnswer - (this.getCurrentTimestamp() - startTimeStamp);
            if (difference < 0) {
                this.timeLeft = 0;
                this.timeOver();
            }
            else {
                this.timeLeft = this.moment.unix(difference);
            }
        }, 1000);
    }

    /**
     * returns current timestamp in seconds
     * @returns {number}
     */
    getCurrentTimestamp () {
        return Math.floor(Date.now() / 1000);
    }

    stopTimer () {
        this.$interval.cancel(this.timer);
    }

    timeOver () {
        this.stopTimer();
        this.FormSubmissionAnswerResource.batchCreate({
            expand: 'form', resend: this.isQuizOverview
        }, this.form).$promise.then((data) => {
            if (data.status === this.FORMS_SUBMISSION_STATUS_ENUM.KEYS.FINISHED) {
                if (!data.isTrial) {
                    this.$state.go('quiz.finished', { guid: data.guid });
                }
                return;
            }
            this.formSubmission = data;
        });
    }

    // sends post message to parent window to close iframe
    closeQuiz () {
        if (this.inFrame) {
            this.ModalService.confirm(this.$translate.instant('quiz.Exit quiz?'), 'small').then(() => {
                parent.postMessage('closeQuiz()', '*');
            });
        }
    }

    triggerSubmit () {
        this.$scope.$broadcast('quiz:submit');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/quiz/index.js